import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { ROUTES } from "config";

export default function GuestRoute({ children }) {
    const { initialized, isAuthenticated } = useSelector((state) => state.auth);

    if (!initialized) {
        return null;
    }

    if (isAuthenticated) {
        return <Navigate to={ROUTES.DASHBOARD} replace />;
    }

    return children;
}
